module.exports = __webpack_public_path__ + "static/img/12.2af566b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/zh/12.png
// module id = xQ3D
// module chunks = 0